export enum IncidentPriorityOption {
  URGENT = "URGENT",
  DEFAULT = "DEFAULT",
}
